import api from "./api";

export const permissionService = {
  getRoles: () => api.get("/permissions/roles"),
  createRole: (data) => api.post("/permissions/roles", data),
  updateRole: (id, data) => api.put(`/permissions/roles/${id}`, data),
  getPermissions: () => api.get("/permissions/permissions"),
  createPermission: (data) => api.post("/permissions/permissions", data),
  updatePermission: (id, data) => api.put(`/permissions/permissions/${id}`, data),
  getRolePermissions: (roleId) => api.get(`/permissions/role-permissions/${roleId}`),
  updateRolePermissions: (roleId, permissionIds) =>
    api.post("/permissions/role-permissions/update", {
      role_id: roleId,
      permission_ids: permissionIds,
    }),
};
